<template>
  <div
    class="h-full p-10px absolute text-white z-99 w-468px rounded-2px right-35px"
    :style="{
      height: location.height,
      top: location.top,
      right: location.float === 'right' ? '25px' : '',
      left: location.float === 'left' ? '25px' : '',
    }"
    id="AddDeviceModel"
  >
    <div>
      <div>
        <el-row class="mb-10px">
          <el-col :span="21">
            <span class="text-14px">{{`${$t('新增工程模型')}`}}</span>
          </el-col>
          <el-col :span="3" class="text-right">
            <span
              class="iconfont float-right cursor-pointer icon-line-close text-12px"
              @click="closeComponent"
            ></span>
          </el-col>
        </el-row>
      </div>
      <div class="w-full">
        <el-select
          ref="classfiySelectTree"
          popper-class="document_select-popper select-tree"
          value-key=""
          clearable
          filterable
          class="w-full"
          size="small"
          @clear="resetDeviesInfo"
          v-model="devicesInfo.folderId"
          placeholder="分类"
        >
          <el-option :label="devicesInfo.pathName" :value="devicesInfo.folderId">
            <el-tree
              :props="{
                label: 'name',
                children: 'children',
              }"
              class="text-white"
              node-key="id"
              highlight-current
              :data="folderTreeData"
              @node-click="classfiyNodeClick"
              :expand-on-click-node="false"
            ></el-tree>
          </el-option>
        </el-select>
      </div>
      <el-row type="flex" align="middle" class="mt-5px">
        <el-col :span="21"
          ><el-input placeholder="名称搜索" v-model="keyWords" clearable size="small"></el-input
        ></el-col>
        <el-col :span="3" class="text-right">
          <el-tooltip effect="dark" content="搜索" placement="top">
            <el-button
              type="primary"
              size="small"
              class="iconfont icon-line-search"
              @click="getComponentList"
            ></el-button>
          </el-tooltip>
        </el-col>
      </el-row>
    </div>
    <div
      class="form_body mt-10px text-white w-full h-[calc(100%-166px)] overflow-y-auto pt-10px pr-5px pb-10px pl-5px"
      v-loading="listLoading"
    >
      <div class="card_list" v-if="listData.length">
        <div
          class="card w-94px h-150px mt-10px mb-10px mr-7px ml-7px"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div class="card_img w-94px h-120px">
            <el-image class="w-full h-full" :src="item.imageUrl">
              <div slot="error" class="text-center leading-132px">
                <i class="el-icon-picture-outline text-24px"></i></div
            ></el-image>
          </div>
          <div
            class="card_text flex w-full h-30px"
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-tooltip effect="dark" :content="item.name" placement="top" :open-delay="1000">
              <el-checkbox
                :disabled="!!currentNode"
                v-model="item.select"
                class="flex items-center"
                @change="(checked) => handleCheckboxChange(checked, index)"
              >
                {{ item.name }}
              </el-checkbox>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="w-full h-full flex items-center justify-center" v-else>
        <span class="text-14px">暂无数据</span>
      </div>
    </div>
    <div
      class="mt-10px w-full flex items-center justify-end"
      @click="
        (e) => {
          e.stopPropagation()
        }
      "
    >
      <el-button type="primary" class="ml-10px" size="mini" @click="createdNewModel"
        >新增</el-button
      >
    </div>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="progressData.loadType"
      :percentage="progressData.loadPercentage"
      v-if="progressData.showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import {
  TheEngineeringModelSceneTreeApi,
  EngineeringModelDataApi,
} from '@wiz-api/cloud-render-management'
import modelFile from '../../assets/js/model/file'
import { FileApi } from '@wiz-api/file-management'
import { loadModel, isJSONObj, generateGUID, EnumObjectTypes } from '../../assets/js/scene/scene'
import downloadFile from '../../assets/js/model/modelDownload'
import {
  find,
  last,
  isNil,
  isEmpty,
  forEach,
  map,
  filter,
  keys,
  sum,
  values,
  cloneDeep,
} from 'lodash'
const fileApi = new FileApi()
const theEngineeringModelSceneTreeApi = new TheEngineeringModelSceneTreeApi()
const engineeringModelDataApi = new EngineeringModelDataApi()
const PlayerProgress = () => {
  return import('../model/PlayerProgress')
}
export default {
  components: {
    PlayerProgress,
  },
  name: 'AddEngineering',
  props: ['location', 'player', 'customProps'],
  watch: {
    'customProps.deleteNode': {
      handler(val, oldVal) {
        // 更新node配置
        this.currentNode = null
      },
      deep: true,
    },
  },
  data() {
    return {
      currentMaterialFile: {}, // 模型贴图文件信息
      loadPosition: [],
      progressData: {
        showLoadProgress: false,
        loadPercentage: 0,
        loadType: '',
      },
      currentModelParams: {},
      modelParams: '', // 模型信息
      // 元件基本信息
      devicesInfo: {
        seqNo: '',
        type: '',
        name: '',
        pathName: '',
        modelFileList: [],
        textureFileList: [],
        thumbnailFileList: [],
        fileName: '',
        thumbnails: '',
        templateAttrSetList: [
          {
            attrValueList: [],
            attributeTemplate: {},
            tableName: '',
            templateId: '',
          },
        ],
      },
      animationConfig: {
        autoPlay: true,
        speed: 1,
        playTimes: true,
      },
      currentNode: null,
      fileList: [],
      folderTreeData: [],
      keyWords: '',
      listData: [],
      listLoading: false,
      fileInstance: null,
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async created() {
    // 判断当前是否已经加载了工程【工程一般在根节点的下一层】
    await this.checkEngineerLoad()
    this.getComponentList()
    this.getFolderTreeData()
  },
  methods: {
    async checkEngineerLoad() {
      const rootItem = await this.player.Native.ModelTree.getRootItems()
      // 在跟节点集合中查找我们设置的场景的跟节点
      const rootNode = find(rootItem, (val) => {
        return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const modelChildren = await this.player.Native.NodeProxy.getNodeChildren(rootNode.nodePtr)
      const modelChild = find(modelChildren, (item) => {
        return item.code && isJSONObj(item.code) && JSON.parse(item.code).type === 'engineering'
      })
      if (modelChild) {
        this.currentNode = modelChild.nodePtr
        this.fileList = JSON.parse(modelChild.code).fileList
        this.animationConfig = JSON.parse(modelChild.code).animationConfig
      }
    },
    handleCheckboxChange(value, index) {
      const checkList = filter(this.listData, ['select', true])
      if (isEmpty(checkList) && value) {
        this.listData = map(this.listData, (e, i) => {
          return {
            ...e,
            select: i === index,
          }
        })
      }
    },
    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      // 下载贴图、物理、动画、工程
      this.fileList = [
        // 工程
        {
          targetUrl: `data://../apps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.engineeringFileId}.pprj`,
          tempPath: `data://../temps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.engineeringFileId}.pprj`,
          fileId: modelParams.engineeringFileId,
          fileUrl: `${
            Wiz.GetApiClientInstance('file-management')?.basePath
          }/api/file-management/files/${modelParams.engineeringFileId}/download`,
          type: 'engineering',
        },
        // 物理
        {
          targetUrl: `data://../apps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.physicsFileId}.physic`,
          tempPath: `data://../temps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.physicsFileId}.physic`,
          fileId: modelParams.physicsFileId,
          fileUrl: `${
            Wiz.GetApiClientInstance('file-management')?.basePath
          }/api/file-management/files/${modelParams.physicsFileId}/download`,
          type: 'physic',
        },
        // 动画
        {
          targetUrl: `data://../apps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.animationFileId}.animation`,
          tempPath: `data://../temps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.animationFileId}.animation`,
          fileId: modelParams.animationFileId,
          fileUrl: `${
            Wiz.GetApiClientInstance('file-management')?.basePath
          }/api/file-management/files/${modelParams.animationFileId}/download`,
          type: 'animation',
        },
      ]
      if (modelParams.engineeringMapFileId) {
        this.fileList.push({
          targetUrl: `data://../apps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.engineeringMapFileId}.zip`,
          tempPath: `data://../temps/${this.modelSetting.folderName}/models/${modelParams.engineeringFileId}/${modelParams.engineeringMapFileId}.zip`,
          fileId: modelParams.engineeringMapFileId,
          fileUrl: `${
            Wiz.GetApiClientInstance('file-management')?.basePath
          }/api/file-management/files/${modelParams.engineeringMapFileId}/download`,
          type: 'map',
        })
      }
      this.fileInstance = new modelFile(this.player, {
        fileList: cloneDeep(this.fileList),
        httpOptions: {
          methods: 'GET',
          header: {
            Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
          },
        },
      })
      window.addEventListener('FileChange', this.connectFileDownload)
    },
    // 监听下载进度

    connectFileDownload({ detail }) {
      const { downloadMap, data } = detail
      if (find(['downloadError', 'moveError'], data)) {
        window.removeEventListener('FileChange', this.connectFileDownload)
        this.fileInstance.disconnect()
        this.progressData.showLoadProgress = false
        this.$message.error('下载失败！')
        return
      }
      this.progressData.loadPercentage = sum(values(downloadMap)) / keys(downloadMap).length
      if (this.progressData.loadPercentage < 100) {
        this.progressData.showLoadProgress = true
        this.progressData.loadType = '下载中...'
      } else {
        window.removeEventListener('FileChange', this.connectFileDownload)
        this.loadNode()
        this.progressData.showLoadProgress = false
      }
    },
    // 加载工程
    async loadNode() {
      const currentFileData = find(this.fileList, ['type', 'engineering'])
      await this.player.Native.NodeProxy.openProject(currentFileData.targetUrl)
      const rootItem = await this.player.Native.ModelTree.getRootItems()
      const currentProjectData = find(rootItem, (el) => {
        return el.name === currentFileData.fileId
      })
      const currentRoot = _.find(rootItem, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      if (currentProjectData) {
        await this.player.Native.NodeProxy.setNodeParent(currentProjectData.nodePtr, rootNode)
        this.currentNode = currentProjectData.nodePtr
        // 设置node的code
        await this.setNodeCode()
        // 加载动画
        await this.loadAnimation(currentProjectData.nodePtr)
        this.$emit('componentEmit', 'addModel', currentProjectData.nodePtr)
        this.$message.success('添加成功')
      } else {
        this.$message.error('添加失败')
      }
    },
    async setNodeCode() {
      const uuid = generateGUID()
      const currentFileData = find(this.fileList, ['type', 'engineering'])
      if (this.currentNode) {
        const codeInfo = {
          id: uuid,
          type: 'engineering',
          filePath: currentFileData.targetUrl,
          modelFileId: currentFileData.fileId,
          animationConfig: this.animationConfig,
          fileList: this.fileList,
        }
        await this.player.Native.NodeProxy.setNodeInfo(this.currentNode, {
          code: JSON.stringify(codeInfo),
        })
      }
    },
    async loadAnimation(parentNode) {
      const currentFileData = find(this.fileList, ['type', 'animation'])
      const animationGroup = await this.player.Native.AnimationMgr.createGroup('pprjAnimation')
      setTimeout(async () => {
        const status = await this.player.Native.AnimationMgr.importAniminationFile(
          animationGroup,
          parentNode,
          currentFileData.targetUrl
        )
        if (this.animationConfig.autoPlay) {
          await this.player.Native.AnimationMgr.start(animationGroup)
        } else {
          await this.player.Native.AnimationMgr.stop(animationGroup)
        }
        await this.player.Native.AnimationMgr.setLoop(
          animationGroup,
          this.animationConfig.playTimes
        )
        await this.player.Native.AnimationMgr.setSpeed(animationGroup, this.animationConfig.speed)
        if (status) {
          this.$message.success('动画加载成功')
        }
      }, 1000)
    },
    /* 加载模型相关end */
    classfiyNodeClick(node) {
      this.devicesInfo.folderId = node.id
      this.devicesInfo.pathName = node.pathName ? node.pathName : node.name
      this.$refs.classfiySelectTree.blur()
      this.getComponentList()
    },
    // 清空筛选
    resetDeviesInfo() {
      this.devicesInfo.folderId = ''
      this.devicesInfo.pathName = ''
    },
    // 获取目录树
    async getFolderTreeData() {
      const [err, res] = await theEngineeringModelSceneTreeApi.getTheEngineeringModelSceneTree()
      if (!err) {
        this.folderTreeData = [{ name: '根目录', id: '', children: res }]
      }
    },
    // 模型点击事件
    async createdNewModel() {
      const checkedModel = find(this.listData, ['select', true])
      if (isEmpty(checkedModel)) {
        this.$message.warning('请选择需要新增的模型')
        return
      }
      this.checkModel(checkedModel)
      forEach(this.listData, (item) => {
        item.select = false
      })
    },
    async getImageContent(id) {
      // 获取图片内容
      const [error, result] = await fileApi.getImageBaseString(id)
      if (!error) {
        return `data:image/png;base64,${result.base64}`
      }
      return ''
    },
    // 加载元件列表
    async getComponentList() {
      this.listData = []
      this.listLoading = true
      const [err, res] = await theEngineeringModelSceneTreeApi.getEngineeringModelFile({
        name: this.keyWords,
        id: this.devicesInfo.folderId,
        skipCount: 0,
        maxResultCount: 1000,
      })
      this.listLoading = false
      if (!err) {
        this.listData = map(res.items, (item) => {
          return {
            ...item,
            select: false,
            imageUrl: '',
          }
        })
        forEach(this.listData, async (item) => {
          const thumbnailId = item.engineeringThumbnailFileId
          if (thumbnailId) {
            const imgRes = await this.getImageContent(thumbnailId)
            this.$set(item, 'imageUrl', imgRes)
          }
        })
      }
    },
    // 关闭弹窗
    closeComponent() {
      if (this.tableLoading) {
        return
      }
      this.$emit('closeComponent', 'AddEngineering')
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/style/select';

.select-tree .el-select-dropdown__item {
  height: unset !important;
  line-height: unset !important;
}

.select-tree .el-tree-node__label {
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
@import '../../assets/style/index';

::v-deep .player_progress {
  position: fixed !important;
}

::v-deep .el-checkbox__label {
  font-size: 12px !important;
}

#AddDeviceModel {
  background-color: rgba(0, 18, 55, 0.3) !important;
  transition: left 0.3s;
}

::v-deep .el-radio {
  margin-right: 10px !important;
}

.form_body {
  background: rgba(24, 41, 72, 0.5);

  ::v-deep .el-loading-mask {
    background: rgba(24, 41, 72, 0.8) !important;
  }

  .card {
    background: none;
    border: none;

    ::v-deep .el-card__body {
      padding: 0 !important;
      background: none;
    }

    ::v-deep .el-checkbox__label {
      overflow: hidden;
      width: 60px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .card_img {
    img {
      width: 100%;
      height: 100%;
    }

    background-color: #383b3b !important;
  }

  .card_list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
  }

  .card_text {
    background: none;

    p {
      height: 30px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      line-height: 30px;
    }

    .el-radio {
      margin: 5px 12px 0 8px;
      color: #fff;
    }
  }
}
</style>
